import { PagedResultDto } from '../table.model';

export interface FullTaxReportDto {
  id: number;
  receiptId: string;
  customerName: string;
  createBill: string;
  siteName: string;
  fee: number;
  vat: number;
  total: number;
  status: string;
  details: string;
}

export interface FullTaxReportByIdDto extends FullTaxReportDto {
  name: string;
  createDate: string;
  reference: string;
  remark: string;
  cardName: string;
  type: string;
  paymentType: string;
  address: string;
  taxId: string;
  telephone: string;
  email: string;
  postcode: string;
  headquarters: boolean;
  branchNo: string | null;
  cpAddressId: number | null;
  cpAddress?: any;
  items: any[];
}

export interface FullTaxReport {
  id: number;
  receiptId: string;
  customerName: string;
  createBill: Date;
  siteName: string;
  fee: number;
  vat: number;
  total: number;
  status: string;
  details: string;
}

export interface FullTaxReportById extends FullTaxReport {
  name: string;
  createDate: Date;
  reference: string;
  remark: string;
  cardName: string;
  type: string;
  paymentType: string;
  address: string;
  taxId: string;
  telephone: string;
  email: string;
  postcode: string;
  headquarters: boolean;
  branchNo: string | null;
  cpAddressId: number | null;
  cpAddress?: any;
  items: any[];
}

export interface FullTaxReportQueryParams {
  siteId: number;
  userId: number;
  page: number;
  pageSize: number;
  startDate?: string;
  endDate?: string;
  // added properties for searching/filtering
  searchField?: string;
  searchText?: string;
  status?: string | 'all';
  sortColumn?: string;
  sortDirection?: 'asc' | 'desc' | '';
}

// Custom response interface that includes totalPages (like original but following standard pattern)
export interface PagedFullTaxResponseDto extends PagedResultDto<FullTaxReportDto> {
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface UpdateFullTaxInvoicePayload {
  userId: number;
  menuId: number;
  id: number;
  customerName: string;
  createBill?: string | null;
  status: string;
  details: string;
  reference: string;
  remark: string;
  cardName: string;
  type: string;
  address: string;
  taxId: string;
  telephone: string;
  email: string;
  postcode: string;
  headquarters: boolean;
  branchNo: string;
  cpAddressId?: number | null;
}

export interface ConfirmFullTaxInvoicePayload {
  id: number;
  userId: number;
  menuId: number;
}

export const FULL_TAX_INVOICE_STATUS = {
  pending: '0',
  confirmed: '1',
  cancelled: '2',
} as const;

export function isFullTaxInvoiceEditable(status: string): boolean {
  return status === FULL_TAX_INVOICE_STATUS.pending;
}
